import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { MainService } from '../main.service';
import { StoreService } from './store.service';
import { StoreAdministrationDto, StoreAdministrationStatus, StoreAvailabilityRequest, UpdateStoreAdministrationRequest } from './store-administration.types';

@Injectable({ providedIn: 'root' })
export class StoreAdministrationService {
  constructor(private http: HttpClient, private main: MainService, private stores: StoreService) {}
  list(status: StoreAdministrationStatus = 'active'): Observable<StoreAdministrationDto[]> {
    return this.http.get<StoreAdministrationDto[]>(`${this.main.getApiURL()}Store/Administration?status=${status}`, { headers: this.main.getHeaders() });
  }
  get(id: number): Observable<StoreAdministrationDto> {
    return this.http.get<StoreAdministrationDto>(`${this.main.getApiURL()}Store/Administration/${id}`, { headers: this.main.getHeaders() });
  }
  update(id: number, body: UpdateStoreAdministrationRequest): Observable<StoreAdministrationDto> {
    const identity = this.main.getSessionIdentity();
    return this.http.put<StoreAdministrationDto>(`${this.main.getApiURL()}Store/Administration/${id}`, body, { headers: this.main.getHeaders() }).pipe(tap(store => this.stores.cacheMutation(store, identity)));
  }
  setAvailability(id: number, isActive: boolean): Observable<StoreAdministrationDto> {
    const identity = this.main.getSessionIdentity();
    const body: StoreAvailabilityRequest = { isActive };
    return this.http.post<StoreAdministrationDto>(`${this.main.getApiURL()}Store/Administration/${id}/availability`, body, { headers: this.main.getHeaders() }).pipe(tap(store => this.stores.cacheMutation(store, identity)));
  }
}
